export function formatDeliveryTypeName(deliveryType: string): string {
  const deliveryTypeMap: { [key: string]: string } = {
    economic: 'Entrega econômica',
    'pick-up': 'Retire na loja',
    fast: 'Entrega rápida',
    'next-day': 'Receba amanhã',
  }

  return deliveryTypeMap[deliveryType] || deliveryType
}
